export const mobileCheck = (width) => {
  return $(window).innerWidth() < width ? true : false;
}
